module.exports = __webpack_public_path__ + "static/logo-fbfbc975e18188bddfe44502bc8c97eb.svg";